import { Eye, EyeOff, X } from "lucide-react";
import React, { useState } from "react";
import { updatePassword } from "../../services/expositor.service";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface PasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PasswordModal({ isOpen, onClose }: PasswordModalProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handlePasswordSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    const items = Object.fromEntries(formData.entries());

    if (items.password !== items.confirm_password) {
      alert("As senhas são diferentes, tente novamente");
    } else {
      updatePassword(items.password as string).then((response) => {
        if (response.status === 200) {
          alert("Senha alterada com sucesso!");
          onClose();
        } else {
          alert("Ocorreu algum erro ao alterar a senha, tente novamente!");
        }
      });
    }
  };

  if (!isOpen) return null;

  let userInfo: any = {};
  try {
    userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  } catch {}

  return (
<div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-2 sm:p-4">
      <Card className="w-full max-w-md bg-white shadow-xl">
        <CardHeader className="flex flex-row items-center justify-between border-b pb-4">
          <CardTitle className="text-gray-900">Alterar Senha</CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-4 h-4" />
          </Button>
        </CardHeader>
<CardContent className="p-4 md:p-6">
          <form onSubmit={handlePasswordSubmit} className="space-y-4">
             <div className="space-y-2">
               <Label htmlFor="password" className="text-gray-700">
                 Nova Senha
               </Label>
               <div className="relative">
                 <Input
                   id="password"
                   name="password"
                   type={showPassword ? "text" : "password"}
                   minLength={6}
                   required
                   className="w-full px-4 py-2 border border-gray-300 rounded-md focus:border-[#24324D] focus:ring-[#24324D] focus:ring-1 focus:outline-none pr-10"
                 />
                 <button
                   type="button"
                   aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                   onClick={() => setShowPassword((v) => !v)}
                   className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
                 >
                   {showPassword ? (
                     <EyeOff className="w-5 h-5" />
                   ) : (
                     <Eye className="w-5 h-5" />
                   )}
                 </button>
               </div>
             </div>

             <div className="space-y-2">
               <Label htmlFor="confirm_password" className="text-gray-700">
                 Confirmar Nova Senha
               </Label>
               <div className="relative">
                 <Input
                   id="confirm_password"
                   name="confirm_password"
                   type={showConfirmPassword ? "text" : "password"}
                   minLength={6}
                   required
                   className="w-full px-4 py-2 border border-gray-300 rounded-md focus:border-[#24324D] focus:ring-[#24324D] focus:ring-1 focus:outline-none pr-10"
                 />
                 <button
                   type="button"
                   aria-label={showConfirmPassword ? "Ocultar confirmação" : "Mostrar confirmação"}
                   onClick={() => setShowConfirmPassword((v) => !v)}
                   className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
                 >
                   {showConfirmPassword ? (
                     <EyeOff className="w-5 h-5" />
                   ) : (
                     <Eye className="w-5 h-5" />
                   )}
                 </button>
               </div>
             </div>

             <div className="flex justify-end space-x-2 pt-4 border-t">
               <Button
                 type="button"
                 variant="outline"
                 onClick={onClose}
                 className="border-gray-300 text-gray-700 hover:bg-gray-50"
               >
                 Cancelar
               </Button>
               <Button
                 type="submit"
                 className="px-4 py-2 bg-[#24324D] text-white rounded-md hover:bg-[#1a2538] transition-colors"
               >
                 Alterar Senha
               </Button>
             </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
